import types from '../actions/types'
import errorHelper from '../helpers/error.helper'
import utils from '../helpers/util.helper'

export default function (state = null, action) {
  switch (action.type) {
    case `${types.LOAD_SITE_APPLICATIONS}_PENDING`:
      return { ...state }
    case `${types.LOAD_SITE_APPLICATIONS}_FULFILLED`:
      return { ...state, errors: {}, items: action.payload.data }
    case `${types.LOAD_SITE_APPLICATIONS}_REJECTED`:
      return { ...state, errors: action.payload.response.data, items: [] }

    case `${types.LOAD_SITE_APPLICATION}_PENDING`:
      return { ...state }
    case `${types.LOAD_SITE_APPLICATION}_FULFILLED`:
      return { ...state, errors: {}, ...utils.snakeToCamelCaseCollection(action.payload.data) }
    case `${types.LOAD_SITE_APPLICATION}_REJECTED`:
      return { ...state, errors: action.payload.response.data }

    case `${types.ADD_SITE_APPLICATION}_PENDING`:
      return { ...state }
    case `${types.ADD_SITE_APPLICATION}_FULFILLED`:
      return { ...state, errors: {}, ...utils.snakeToCamelCaseCollection(action.payload.data) }
    case `${types.ADD_SITE_APPLICATION}_REJECTED`:
      return { errors: errorHelper.buildErrors(action.payload.response.data.errors) }

    case `${types.UPDATE_SITE_APPLICATION}_PENDING`:
      return { ...state }
    case `${types.UPDATE_SITE_APPLICATION}_FULFILLED`:
      return { ...state, errors: {}, ...utils.snakeToCamelCaseCollection(action.payload.data) }
    case `${types.UPDATE_SITE_APPLICATION}_REJECTED`:
      return { errors: errorHelper.buildErrors(action.payload.response.data.errors) }

    default:
      return state
  }
}
